import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/lib/theme";
import { PeriodProvider } from "@/components/PeriodFilterBar";
import { TOKEN_KEY } from "@/lib/api";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import DailyBrief from "@/pages/DailyBrief";
import Pulse from "@/pages/Pulse";
import Festivals from "@/pages/Festivals";
import Departments from "@/pages/Departments";
import StockOverview from "@/pages/StockOverview";
import DeadStock from "@/pages/DeadStock";
import VendorScorecard from "@/pages/VendorScorecard";
import Procurement from "@/pages/Procurement";
import HrOverview from "@/pages/HrOverview";
import HrAttendance from "@/pages/HrAttendance";
import HrAttrition from "@/pages/HrAttrition";
import HrPerformance from "@/pages/HrPerformance";
import HrDemographics from "@/pages/HrDemographics";
import HrWeeklyOff from "@/pages/HrWeeklyOff";

function RequireAuth({ children }) {
  const t = typeof window !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
  if (!t) return <Navigate to="/login" replace />;
  return children;
}

function Shell({ children }) {
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <ThemeProvider>
      <PeriodProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: "hsl(var(--popover))",
              color: "hsl(var(--popover-foreground))",
              border: "1px solid hsl(var(--border))",
              borderRadius: "0",
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "12px",
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/daily" replace />} />
            <Route path="/daily" element={<RequireAuth><Shell><DailyBrief /></Shell></RequireAuth>} />
            <Route path="/pulse" element={<RequireAuth><Shell><Pulse /></Shell></RequireAuth>} />
            <Route path="/sales" element={<Navigate to="/sales/festivals" replace />} />
            <Route path="/sales/festivals" element={<RequireAuth><Shell><Festivals /></Shell></RequireAuth>} />
            <Route path="/sales/departments" element={<RequireAuth><Shell><Departments /></Shell></RequireAuth>} />
            <Route path="/stock" element={<Navigate to="/stock/overview" replace />} />
            <Route path="/stock/overview" element={<RequireAuth><Shell><StockOverview /></Shell></RequireAuth>} />
            <Route path="/stock/dead-stock" element={<RequireAuth><Shell><DeadStock /></Shell></RequireAuth>} />
            <Route path="/stock/vendors" element={<RequireAuth><Shell><VendorScorecard /></Shell></RequireAuth>} />
            <Route path="/procurement" element={<RequireAuth><Shell><Procurement /></Shell></RequireAuth>} />
            <Route path="/hr" element={<Navigate to="/hr/overview" replace />} />
            <Route path="/hr/overview" element={<RequireAuth><Shell><HrOverview /></Shell></RequireAuth>} />
            <Route path="/hr/attendance" element={<RequireAuth><Shell><HrAttendance /></Shell></RequireAuth>} />
            <Route path="/hr/attrition" element={<RequireAuth><Shell><HrAttrition /></Shell></RequireAuth>} />
            <Route path="/hr/performance" element={<RequireAuth><Shell><HrPerformance /></Shell></RequireAuth>} />
            <Route path="/hr/demographics" element={<RequireAuth><Shell><HrDemographics /></Shell></RequireAuth>} />
            <Route path="/hr/weekly-off" element={<RequireAuth><Shell><HrWeeklyOff /></Shell></RequireAuth>} />
            <Route path="*" element={<Navigate to="/daily" replace />} />
          </Routes>
        </BrowserRouter>
      </PeriodProvider>
    </ThemeProvider>
  );
}
